(function() {
    angular.module('emarket.store').directive('emStoreCategoriesMenu', ['$log', '$mdPanel', function($log, $mdPanel) {
        return {
            scope: {
                sticky: '=',
                categories: '=',
                compact: '='
            },
            link: function(scope, element) {
                var actionBtnClass = '.store__category__title';
                scope.limit = 7;
                var position = $mdPanel
                    .newPanelPosition()
                    .relativeTo(actionBtnClass)
                    .addPanelPosition($mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.BELOW);

                element.find(actionBtnClass).on('click', function(ev) {
                    if (scope.categories.length <= scope.limit && scope.sticky) {
                        return;
                    }
                    var config = {
                        controller: 'StoreCategoriesMenuController as vm',
                        templateUrl: 'store/store-categories-menu/store.categories.menu.panel.tpl.html',
                        position: position,
                        clickOutsideToClose: true,
                        escapeToClose: true,
                        openFrom: ev,
                        disableParentScroll: true,
                        panelClass: 'store-categories-menu-panel',
                        locals: {
                            categories: scope.categories,
                            compact: scope.compact,
                            sticky: scope.sticky
                        },
                        zIndex: 2
                    };
                    $mdPanel.open(config);
                });
            },
            templateUrl: 'store/store-categories-menu/store.categories.menu.tpl.html'
        };
    }]);
}());
